import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Button, ButtonGroup, Card, CardBody, CardHeader } from "reactstrap";
import { Typography } from "@mui/material";
import visibleColumns from "./visibleColumns";
import useSortedColumns from "../../../../utils/useSortedColumns";
import { useAuth } from "oidc-react";
import AdvanceSearch from "../../../../CommonComponents/AdvanceSearch";
import TelerikDataTableV2 from "../../../../CommonComponents/TelerikDataTable";
import { loadingPanel } from "../../../../CommonComponents/CommonFunction";

const LeaveReportSummary = ({ searchParams, additionalWhere, isVisible, header, headerContent,isSearchTriggered }) => {
  const id = "leaveReportSummaryData";

  // State for TelerikDataTable
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [sortData, setSortData] = useState([
    { field: "paycode_name", dir: "asc" },
  ]);
  const [mappedResults, setMappedResults] = useState([]);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [localSearchParams, setLocalSearchParams] = useState(searchParams);
  const [localAdditionalWhere, setLocalAdditionalWhere] =
    useState(additionalWhere);
  const [groupBy, setGroupBy] = useState(null);

  const {
    columns,
    loadingSearch,
    searchResults,
    ColumnsSorted,
    searchParameter,
    // searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);

  

    const { results, rowCount } = useSelector(
        (state) => state.advanceSearchv2Reducer.searchResultsV2?.[id] || { results: [], rowCount: 0 }
      );
    
    //   const columns = useSelector(
    //         (state) => state.advanceSearchv2Reducer.columnsById?.[id] || []
    //     );
        
    //     // const loadingSearch = useSelector(
    //     //     (state) => state.advanceSearchv2Reducer.loadingById?.[id] || false
    //     // );
        
    //     const { ColumnsSorted, searchParameter } = useSelector((state) => state.advanceSearchv2Reducer);

  const { userData } = useAuth();

  const [sortedColumns, setSortedColumns] = useSortedColumns(
    id,
    ColumnsSorted,
    columns,
    visibleColumns,
    userData,
  );

  let runsortColumns = useRef(true)
  useEffect(() => {
    if(!runsortColumns.current || !sortedColumns || sortedColumns.length === 0){
      return
    }
    let tempSortedColumns = [...sortedColumns];
    setSortedColumns(tempSortedColumns.map((item)=>{
      if(item.field === "employee_name" || item.field === "DepartmentName"){
        return {
            ...item,
            show: false
        }
      }
      return item
    }));
    runsortColumns.current = false
  }, [sortedColumns]);

  // Handlers for pagination and sorting
  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => setSortData(sort);
  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  const newResult = useMemo(() => JSON.stringify(results), [results]);
  useEffect(() => {
    if (results && results.length > 0) {
      setMappedResults(results);
    } else {
      setMappedResults([]);
    }
  }, [newResult]);

  const searchParamsDependency = useMemo(
    () => (searchParams.length ? JSON.stringify(searchParams) : "searchParams"),
    [searchParams]
  );

  useEffect(() => {
    setLocalSearchParams(searchParams);
    setLocalAdditionalWhere(additionalWhere);
    
  }, [searchParamsDependency, additionalWhere]);

  useEffect(() => {
    const baseParams = searchParams || [];

    const filteredParams = baseParams.filter((p) => p.columnName !== groupBy);

    if (groupBy) {
      setLocalSearchParams([
        ...filteredParams,
        {
          columnName: groupBy,
          value: "alpha",
          operator: "=",
          dataType: "VARCHAR(MAX)",
          id: "1233456",
        },
      ]);
      let tempSortedColumns = [...sortedColumns];
      for (let item of tempSortedColumns) {
         if (
              item.field === "employee_name" ||
              item.field === "DepartmentName"
            ) {
              if (!groupBy) {
                item.show = false;
              }
              if (groupBy === "DeptName") {
                if (item.field === "employee_name") {
                  item.show = false;
                }
                if(item.field === "DepartmentName"){
                    item.show = true;
                }
              }
              if (groupBy === "Empname") {
                if (item.field === "DepartmentName") {
                  item.show = false;
                }
                if(item.field === "employee_name"){
                    item.show = true;
                }
              }
            } 
      }
        setSortedColumns(tempSortedColumns);
          
    } else {
      let tempSortedColumns = [...sortedColumns];
      for (let item of tempSortedColumns) {
        if (
              item.field === "employee_name" ||
              item.field === "DepartmentName"
            ) {
              if (!groupBy) {
                item.show = false;
              }
            }
      }
        setSortedColumns(tempSortedColumns);

      setLocalSearchParams(filteredParams);
    }
  }, [searchParamsDependency, groupBy]);

  const handleFilterChange = (data) => {
    setLocalAdditionalWhere(data);
    setPage(1);
  };

//   useEffect(() => {
//     alert("Leave Report Summary");
//   }, []);

  if (!isVisible || !isSearchTriggered) {
    return null;
  }

  console.log(sortedColumns,'sortedColumnssummarydata')

  return (
    <Card className="mt-4 shadow-sm">
      {/* <CardHeader className="bg-light">
        <Typography variant="h6">Leave Report Details</Typography>
      </CardHeader> */}
      <CardHeader className="bg-light d-flex justify-content-between align-items-center">
        <Typography variant="h6">Leave Report Summary</Typography>
        {/* <div className="d-flex align-items-center">
          <Typography
            variant="body1"
            className="me-3"
            style={{ color: "black" }}
          >
            <strong>Group By:</strong>
          </Typography>
          <ButtonGroup>
            <Button
              color={!groupBy ? "primary" : "secondary"}
              onClick={() => setGroupBy("")}
            >
              None
            </Button>
            <Button
              color={groupBy === "DeptName" ? "primary" : "secondary"}
              onClick={() => setGroupBy("DeptName")}
            >
              Department
            </Button>
            <Button
              color={groupBy === "Empname" ? "primary" : "secondary"}
              onClick={() => setGroupBy("Empname")}
            >
              Employee Name
            </Button>
          </ButtonGroup>
        </div> */}
      </CardHeader>
      <CardBody>
        <AdvanceSearch
          key={id}
          id={id}
          gridId={id}
          location="global-optimize"
          columnLocation="global"
          columnList={"*"}
          columnRefernces={[]}
          tableName="sp_EmployeeHRleavereportSummary"
          searchParams={localSearchParams}
          forceParams={localSearchParams}
          additionalWhere={localAdditionalWhere}
          pageNumber={page}
          pageSize={pageSize}
          sortData={sortData}
          sortBy={sortData[0]?.field || ""}
          orderBy={sortData[0]?.dir || ""}
          chooseFilterMethod={chooseFilterMethod}
        />

        {loadingSearch && loadingPanel()}
                {isSearchTriggered && sortedColumns?.length > 0 && (
<TelerikDataTableV2
          id={id}
          pageSize={pageSize}
          totalCount={rowCount}
          skip={(page - 1) * pageSize}
          take={pageSize}
          data={mappedResults}
          sortData={sortData}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
          onPageSizeChange={handlePageSizeChange}
          onFilterChange={handleFilterChange}
          selectedColumns={sortedColumns}
          setSortedColumns={setSortedColumns}
          loading={loadingSearch}
          isDashboard={true}
          setChooseFilterMethod={setChooseFilterMethod}
          chooseFilterMethod={chooseFilterMethod}
          header={true}
          headerContent={headerContent}
          headerNameOptional={"LeaveReport"}
        />
                )}
        
      </CardBody>
    </Card>
  );
};

export default LeaveReportSummary;
